export const lines = [
  [0, 1],
  [1, 2],
  [2, 3],
  [3, 4],
  [0, 6],
  [6, 7],
  [7, 8],
  [8, 9],
  [14, 15],
  [15, 16],
  [18, 19],
  [19, 20],
  [14, 18],
  [0, 12],
  [12, 13],
  [13, 14],
  [13, 18],
  [16, 31],
  [20, 31],
];
export const handedness = {
  right: "rightHanded",
  left: "leftHanded",
};
export const RoleId = {
  4: "Coach",
  5: "Striker",
};
export const ROLE = {
  Coach: "Coach",
  Striker: "Striker",
};
export const handednessId = {
  2: "Right Handed",
  1: "Left Handed",
};
export const HANDEDNESS = {
  rightHanded: "Right Handed",
  leftHanded: "Left Handed",
};
export const GenderID = {
  1: "Male",
  2: "Female",
};
export const gender = {
  Male: "Male",
  Female: "Female",
};
export const PlanID = {
  1: "Free",
  2: "3 Months",
  3: "6 Months",
  4: "1 Year",
};

export const appColors = {
  yellow: "#f4b821",
  blue: "#cd2a3f",
  green: "#7bb728",
  darkYellow: "#B78E00",
  darkGreen: "#629220",
};

export const fullSwing = "full swing";
export const downTheLine = "DownTheLine";

export const MONTHS = {
  "1m": "1 Month",
  "3m": "3 Months",
  "6m": "6 Months",
  "12m": "12 Months",
};
export const SUBSCRIPTION_NAMES = {
  1: "Trial",
  3: "Basic",
  6: "Standard",
  12: "Premium",
};

export const dummyPdf =
  "https://m2c-smiles-cases.s3.eu-central-1.amazonaws.com/2025-234-OB29/rentalAgreement/demo2.pdf?response-content-disposition=inline&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEBwaDGV1LWNlbnRyYWwtMSJHMEUCIQCuSsKcD5S9EsksWCzp818E7WZ9oFm8z8P8IbXF5Z1enwIgGF6zrYzDUPYKWcPiOEamNKJjV4kOkGgYn6MaqOyl2Dkq1gMIdRACGgw1OTA3OTYzNzc4OTIiDC54irwrv%2BDUcnQTBCqzA%2BgDF3doYHWEg6sL6l2Jj%2Bgxtn2AoiEty6nHRRvbaN4%2BbOHZksRllcynJ2SxVRNRJ9SY0%2FS9WgWoOHe9Ivjc4V5BvvL73z%2FU9oyHJB2xIBm1E60gCyrETj7VB0nEkydsnGijyMTeaJ8Mzryn50AlfVUW6RX83hDl5jrFq9NBFaS9l%2BXxticxyiM0Niy%2FIqQbgbyRVWWc9McwgETAVsxlbbmEtYnE5htISxyQ9zXbdnrv527bL22R%2BvhCCMcCKR50O9CMLHPe82WqLPcY%2Bo64R2auxlm9ZQSvihLuRu7Pq1lDcIGsE58uU7MV3hSs%2F7T2mGVpnB%2BEocie%2FthDCPeXSsfNGbJEsENxnFnj%2FqUI5m2LmxVuRco3bN7i349eNl08AaxQaewuux5Gdc86L9aI56BlmPyvflOSncQgadAb%2FcRUKBsrVLk%2BPubStn6Ib5EmNsfj3rbjrtJGU0JrBJtwooojFoSYSHO5x%2BU46yQZ4b6TgAbyuDtaZkiDnKM8f41ZpQt7h0BXJ78HcrsON1871ZFLThDkrpTcPDVfSrp8pv7JVX6qoGNWddtXLj8QOLQNBXanDzCHu7XFBjreAsVT33MnqoC9sv9XlGzvA7pwBUF0qegNpGDuSijOczf2r4Gishnl8ALbAaTZ5xZkdNkygfXfy6EnaVM9b6c7ZC7CGwQeiHpJnCOaLmPD1hejcGXz7C96yJ9%2FdmMviSaqc%2Br0uiWWyoTC84Iqt7LUxKwVb7weN2c16D7Zzck84cHlagbp%2FPQ2JtfBozBK5aXAbBjlLI9cOY8hv%2BeVRlmQ%2FlKu0e%2FmaeIeKiRtupm%2FmakqbSMeQvYdZ2CVy7Hsci1SoxuLttoucjltXoHiyDJQNWg5tdqMob1n7pk2%2F7xOLrVlvYVoYp00V3ij4Gak%2F%2FKQ44rqKEvntHxJ5Qficx4V5qTD5bT6h1rW9%2Bu86v%2BOU1lFyn8Ez8W7I1OhhLr1Fy5lqMqOmRUy0vk2BwHOxq9jSliFRN1C8CncqLn456KudIK7aBj6nf1bdPU%2B0PBoBcf16XwikHIwj0VjrX9fKpeP&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIAYTDRVJ4SHOJJ7DK7%2F20250826%2Feu-central-1%2Fs3%2Faws4_request&X-Amz-Date=20250826T120443Z&X-Amz-Expires=10800&X-Amz-SignedHeaders=host&X-Amz-Signature=1974278d5a43d8d364cce310cf3245af48ea057fa3889a40fb929eab0a2891c9";

export function getInitialLetters(username) {
  if (!username) return;
  const result = username.trim().split(/\s+/).filter(Boolean);
  let firstLetter = "";
  let lastLetter = "";
  if (result.length > 0) {
    firstLetter = result[0][0];
  }
  if (result.length > 1) {
    lastLetter = result[result.length - 1][0];
  }

  return result.length > 0 ? (firstLetter + lastLetter).toUpperCase() : "";
}
export const ENVIORNMENTS = {
  LIVE: "live",
  SANDBOX: "sandbox",
  ENVIORNMENT: "enviornment",
};
export function getCurrentEnviornment() {
  return sessionStorage.getItem(ENVIORNMENTS.ENVIORNMENT) || ENVIORNMENTS.LIVE;
}
export const localStorageLiveUserId = () => {
  return localStorage.getItem(`${ENVIORNMENTS.LIVE}_userId`);
};
export const localStorageSandboxUserId = () => {
  return localStorage.getItem(`${ENVIORNMENTS.SANDBOX}_userId`);
};
export const localStorageCurrentEnvUserId = () => {
  return localStorage.getItem(`${getCurrentEnviornment()}_userId`);
};
export const REACT_APP_baseURL_sandbox =
  "https://srpfmba38f.execute-api.eu-central-1.amazonaws.com/dev";

export const REACT_APP_baseURL =
  "https://1xhtvay1ec.execute-api.eu-central-1.amazonaws.com/prod";
